var _path, _rect, _rect2, _circle, _circle2, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewStorage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 1.33c.421.159 5.047-1.265 6.88.811C9.713 4.217 12.5 21.5 12.5 21.5",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.204,
    y: 0.672,
    width: 9.858,
    height: 5.557,
    rx: 1,
    transform: "matrix(.9551 -.29631 .24854 .96862 12.235 8.635)",
    stroke: "currentColor",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.204,
    y: 0.672,
    width: 15.207,
    height: 5.557,
    rx: 1,
    transform: "matrix(.9551 -.29631 .24854 .96862 14.575 17.466)",
    stroke: "currentColor",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 28,
    r: 3,
    stroke: "currentColor",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 28,
    r: 0.9,
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.95732 -.28902 .24226 .97021 19.662 27.171)",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    d: "M1-1h11.122"
  })));
}
export default SvgNewStorage;